import type { ColDef } from "ag-grid-community";
import type React from "react";
import { useMemo } from "react";
import type { Operator } from "../../models/Operator";
import { CheckboxRenderer } from "../CheckboxRenderer";
import { buttonsCellRenderer } from "./buttonsCellRenderer";

type Props = {
	editOperator: (operator: Operator) => void;
	deleteOperator: (operator: Operator) => void;
	showContextMenu: (
		event: React.MouseEvent,
		data: Operator,
		configId: string,
	) => void;
};

const CELL_STYLE = {
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
};

export const useTableOperators = ({
	editOperator,
	deleteOperator,
	showContextMenu,
}: Props) => {
	const columnDefs = useMemo<ColDef[]>(
		() => [
			{
				field: "OperatorName",
				headerName: "Name",
				flex: 1,
				minWidth: 20,
				cellStyle: CELL_STYLE,
			},
			{
				field: "AssetName",
				headerName: "Assets",
				flex: 1,
				minWidth: 20,
				cellStyle: CELL_STYLE,
				valueGetter: ({ data }) => data?.AssetName?.trim() || "-",
			},
			{
				field: "Enabled",
				headerName: "Enabled",
				minWidth: 20,
				flex: 1,
				cellRenderer: CheckboxRenderer,
			},
			{
				headerName: "",
				field: "-",
				cellRenderer: buttonsCellRenderer,
				cellRendererParams: {
					editOperator,
					deleteOperator,
					showContextMenu,
				},
				sortable: false,
				filter: false,
				flex: 1,
				minWidth: 200,
				wrapText: false,
				autoHeight: false,
				wrapHeaderText: false,
				autoHeaderHeight: true,
				cellStyle: CELL_STYLE,
			},
		],
		[deleteOperator, editOperator, showContextMenu],
	);

	return { columnDefs };
};
